import React from "react";
import AlertLineReportNotes from "../../../../../containers/AlertLineReportNotes/AlertLineReportNotes";
import { AlertLineReportDTO } from "../../../../../models/alert-line-report/alert-line-report-dto";

interface Props {
  alertLineReport: AlertLineReportDTO;
}

const PreviousAlerLineReportNotes = ({ alertLineReport }: Props) => {
  return (
    <>
      <AlertLineReportNotes alertLineReport={alertLineReport} />
    </>
  );
};
export default PreviousAlerLineReportNotes;
